import { compose, withHandlers } from 'recompose';
import { UserPartial } from 'user';

import withUser, { WithUserProps } from '../../../../HOCs/withUser';

type HOCs = WithUserProps;
type Handlers = {
  onSubmit: (user: UserPartial) => void;
};

export default compose(
  withUser,
  withHandlers<HOCs, Handlers>({
    onSubmit: ({ updateUser }) => ({ avatar, ...user }) => updateUser(user)
  })
);
